function clearStorage() {
    return new Promise((res) => res());
}

export default clearStorage;
